export default [
    {
        path: '/',
        label: '首页',
        key: 'index',
        component: () => import('@/components/pages/index')
    },
    {
        path: '/introduce',
        label: '贝塔简介',
        key: 'introduce',
        component: () => import('@/components/pages/introduce'),
        children: [
            {
                path: '/introduce?active=intro1',
                key: 'intro1',
                label: '公司简介',
            },
            {
                path: '/introduce?active=intro2',
                key: 'intro2',
                label: '愿景使命',
            },
            {
                path: '/introduce?active=intro3',
                key: 'intro3',
                label: '核心价值&工作理念',
            },
            {
                path: '/introduce?active=intro4',
                key: 'intro4',
                label: '我们的office',
            }
        ]
    },
    {
        path: '/game',
        label: '贝塔游戏',
        key: 'game',
        component: () => import('@/components/pages/gameNew')
    },
    {
        path: '/publish',
        label: '贝塔发行',
        key: 'publish',
        component: () => import('@/components/pages/publish'),
    },
    {
        path: '/life',
        label: '贝塔生活',
        key: 'life',
        component: () => import('@/components/pages/life')
    },
    {
        path: '/dynamic',
        label: '贝塔动态',
        key: 'dynamic',
        component: () => import('@/components/pages/dynamic')
    },
    {
        path: '/joinus',
        label: '加入我们',
        key: 'joinus'
    }
]



// WEBPACK FOOTER //
// ./src/router/routerLists.js